import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import type { TourDocumentView } from 'entities/tour/models/document'

import { copyText } from 'shared/lib/copyText'
import { previewPdfUrl } from 'shared/lib/pdf-preview'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Button } from 'shared/ui/button'
import { message } from 'shared/ui/message'

import common from '../../styles.module.scss'

import s from './styles.module.scss'

interface Props {
  document: TourDocumentView
}

export const ContractCard: FC<Props> = ({ document }) => {
  const { t } = useTranslation()

  if (!document.documentNumber && !document.documentUrl) return null

  const handleCopy = () => {
    if (!document.documentNumber) return

    copyText(document.documentNumber)
    message.copy(t('copied_to_clipboard'))
  }
  return (
    <section className={common.card}>
      <div className={common.row}>
        <div>
          <h2 className="bold-16">{t('tourDetails.contractNumber')}</h2>
          {document.documentNumber && (
            <p className={clsx(common.caption, 'regular-14')}>
              № {document.documentNumber}
            </p>
          )}
        </div>
        {document.documentNumber && (
          <Button
            variant="transparent"
            className={s.copy}
            aria-label={t('tourDetails.contractNumber')}
            onClick={handleCopy}
          >
            <AppIcon
              id={AllIcons.COPY_ALT}
              width={24}
              height={24}
            />
          </Button>
        )}
      </div>
      {document.documentUrl && (
        <Button
          variant="transparent"
          className={clsx(common.link, 'medium-14')}
          onClick={() => previewPdfUrl(document.documentUrl ?? undefined)}
        >
          {t('tourDetails.openContract')}
        </Button>
      )}
    </section>
  )
}
